module.exports = __webpack_public_path__ + "img/ISFP.b3924cc5.png";